import React from "react";
import { Header } from "./Header";
import { HeaderMenu } from "./HeaderMenu";
import { Outlet } from "react-router-dom";
import '../styles/Home.css';

/**
 * Layout component that defines the overall structure of the page.
 * 
 * @returns {JSX.Element} The rendered layout with header, menu, and outlet for nested routes.
 */
export function Layout() {
  return (
    <>
      <Header />
      <HeaderMenu />
      <div className="page-container">
        <Outlet />
      </div>
    </>
  );
}
